import loadable from 'src/utils/loadable';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "components.devonlydashboard" */ './DevOnlyDashboard.component'
    ),
);
